import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";
import { Reveal, SectionLabel } from "./Reveal";

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative bg-[#050607] py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="grid gap-8 lg:grid-cols-2 lg:items-end">
        <div>
          <SectionLabel index="01">What We Do</SectionLabel>
          <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Six Core Services.<br /><span className="text-neutral-500">One Trusted Team.</span></h2>
        </div>
        <p className="max-w-md text-neutral-400 lg:justify-self-end">Every job, large or small, is handled by experienced engineers using modern equipment, with clear communication from start to finish.</p>
      </Reveal>
      <div className="mt-16 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 80} className="bg-[#050607]">
            <a href="#contact" data-testid={`service-card-${i + 1}`} className="service-card group block h-full p-8 md:p-10">
              <div className="flex items-start justify-between">
                <div className="grid h-14 w-14 place-items-center border border-[#1E9BFF]/40 bg-[#1E9BFF]/10 text-[#1E9BFF] transition-colors duration-300 group-hover:bg-[#1E9BFF] group-hover:text-black">
                  <s.icon className="h-7 w-7" strokeWidth={1.6} />
                </div>
                <span className="font-mono text-xs text-neutral-600">0{i + 1}</span>
              </div>
              <h3 className="mt-8 font-display text-2xl font-bold uppercase leading-tight">{s.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-neutral-400">{s.text}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#1E9BFF] opacity-70 transition-opacity group-hover:opacity-100">
                Enquire <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
